module.exports = __webpack_public_path__ + "static/media/ru.b49e024e.png";